import { useDraggable } from '@dnd-kit/core';
import type { KanbanTaskCardProps } from './kanban-task-card.types.ts';
import styles from './kanban-task-card.module.scss';

export function KanbanTaskCard({ className, children, data, isOverlay = false }: KanbanTaskCardProps) {
  const { attributes, listeners, isDragging, setNodeRef } = useDraggable({
    id: data.id,
    data: { ...data },
  });

  let cardClassName = `${styles.card} ${className}`;
  if (isDragging) cardClassName += ` ${styles.dragging}`;
  if (isOverlay) cardClassName += ` ${styles.overlay}`;

  return (
    <div ref={setNodeRef} className={cardClassName} {...listeners} {...attributes}>
      {children}
    </div>
  );
}
